/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportTemplateListDto_Wealthlane_ReportService_Application_Contracts } from '../models/Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportTemplateListDto_Wealthlane_ReportService_Application_Contracts';
import type { Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto';
import type { Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto } from '../models/Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto';
import type { Wealthlane_ReportService_Dtos_PublishedReportTemplate_AdoptPublishedTemplateRequestDto } from '../models/Wealthlane_ReportService_Dtos_PublishedReportTemplate_AdoptPublishedTemplateRequestDto';
import type { Wealthlane_ReportService_Dtos_PublishedReportTemplate_AdoptPublishedTemplateResponseDto } from '../models/Wealthlane_ReportService_Dtos_PublishedReportTemplate_AdoptPublishedTemplateResponseDto';
import type { Wealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportListType } from '../models/Wealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportListType';
import type { Wealthlane_ReportService_Dtos_PublishedReportTemplate_PublishReportTemplateRequestDto } from '../models/Wealthlane_ReportService_Dtos_PublishedReportTemplate_PublishReportTemplateRequestDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class PublishedReportTemplateService {

    /**
     * @param requestBody 
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto OK
     * @throws ApiError
     */
    public static postApiReportApiAppPublishedReportTemplatePublishReportTemplate(
requestBody?: Wealthlane_ReportService_Dtos_PublishedReportTemplate_PublishReportTemplateRequestDto,
): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/published-report-template/publish-report-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param categoryIds 
     * @param areaIds 
     * @param listType 
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportTemplateListDto_Wealthlane_ReportService_Application_Contracts OK
     * @throws ApiError
     */
    public static getApiReportApiAppPublishedReportTemplatePublishedReportTemplates(
categoryIds?: Array<string>,
areaIds?: Array<string>,
listType?: Wealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportListType,
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<Volo_Abp_Application_Dtos_PagedResultDto_1OfOfWealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportTemplateListDto_Wealthlane_ReportService_Application_Contracts> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/published-report-template/published-report-templates',
            query: {
                'CategoryIds': categoryIds,
                'AreaIds': areaIds,
                'ListType': listType,
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_ReportService_Dtos_PublishedReportTemplate_AdoptPublishedTemplateResponseDto OK
     * @throws ApiError
     */
    public static postApiReportApiAppPublishedReportTemplateAdoptPublishedTemplate(
requestBody?: Wealthlane_ReportService_Dtos_PublishedReportTemplate_AdoptPublishedTemplateRequestDto,
): CancelablePromise<Wealthlane_ReportService_Dtos_PublishedReportTemplate_AdoptPublishedTemplateResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/report/api/app/published-report-template/adopt-published-template',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @param listType 
     * @returns Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto OK
     * @throws ApiError
     */
    public static getApiReportApiAppPublishedReportTemplatePublishedReportTemplateById(
id: string,
listType?: Wealthlane_ReportService_Dtos_PublishedReportTemplate_PublishedReportListType,
): CancelablePromise<Wealthlane_ReportService_Dtos_CustomReport_CustomReportDetailDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/report/api/app/published-report-template/{id}/published-report-template-by-id',
            path: {
                'id': id,
            },
            query: {
                'listType': listType,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
